import { useNavigate, useSearchParams, useParams, useLocation, useOutletContext } from 'react-router-dom'
import { useEffect, useState, startTransition } from 'react'
import api from 'helpers/api'
import { parseToken } from 'helpers/auth'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import Loader from 'components/assets/icons/Loader'
import Button from "components/common/Button/Button"
import style from './Intro.module.scss'

const RCProIntro = () => {
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const project = pathname.split('/')[1]
  const previous = localStorage.getItem(project === 'rc-pro' ? 'RCPro' : project)
  const [ popup, setPopup ] = useState(previous !== null)
  const [ texts, setTexts ] = useState({})
  const { page, savedState } = previous ? JSON.parse(previous) : {}
  const { intro, comeback } = texts
  const [ searchParams ] = useSearchParams()
  const params = useParams() 
  const token = searchParams.get('token')
  const adhesionId = parseToken(token)?.adhesionId
  const contractType = params.id
  const priceType = searchParams.get('priceType')
  const rateType = searchParams.get('rateType')
  const { setPartnerLogo } = useOutletContext()

  // Get pages texts
  useEffect( () => {
    const getDatas = async () => {
      try{
        const adhesion = adhesionId
          ? await api.get({
            url: `/adhesions/${adhesionId}/subscription`,
            headers: { Authorization: `Bearer ${token}` }
          })
          : {}

        const priceTypeID = priceType || adhesion.priceType
        const rateTypeID = rateType || adhesion.rateType

        const list = contractType && priceTypeID && rateTypeID
          ? await api.get({
            url: `/RCPro/${contractType}/${priceTypeID}/${rateTypeID}/wording`,
            headers: { Authorization: `Bearer ${token}` }
          })
          : null

        if (list) {
          setTexts(list)
          setPartnerLogo(list.logo)

          if (adhesionId){
            const phone = parsePhoneNumberFromString(adhesion.phone)
            adhesion.phone = {
              number: adhesion.phone.replace('+', ''),
              countryCode: phone ? phone.country.toLowerCase() : 'fr'
            }
            adhesion.adhesionId = adhesion._id
            startTransition(() => {
              const newState = {
                texts: list,
                token,
                contractType,
                priceType: priceTypeID,
                rateType: rateTypeID,
                ...adhesion
              }
              localStorage.setItem(project === 'rc-pro' ? 'RCPro' : project, JSON.stringify({
                page: 'estimate',
                savedState: newState
              }))
              navigate("./estimate", {
                replace: true,
                state: newState
              })
            })
          }
        } else {
          navigate('./oups?reason=401', { state: {
            ...state,
            errMessage: `GET /RCPro/${contractType}/${priceType}/${rateType}/wording (token: ${token}) returned nothing`
          }})
        }
      } catch (err) {
        navigate('./oups?reason=401', { state: {
          ...state,
          errMessage: `GET /RCPro/${contractType}/${priceType}/${rateType}/wording (token: ${token}) returned ${err.message}`
        }})
      }
    }
    getDatas()
  }, [token, contractType, priceType, rateType, adhesionId, navigate, state, setPartnerLogo, project])


  if (adhesionId) return
  return !Object.keys(texts).length
  ? <div className={style.loading}><Loader /></div>
  : popup 
  ? (
    <div className={style.popup}>
      <h1>{comeback?.title} 👀</h1>
      <p>{comeback?.message}</p>
      <Button
        label={comeback?.yes}
        onClick={() => navigate('./'+page, { state: savedState })}
      />
      <Button
        label={comeback?.no}
        onClick={() => setPopup(false)}
      />
    </div>
  ) : (
    <div className={style.content}>
      <h1>{intro?.title} ⏱️</h1>
      <p dangerouslySetInnerHTML={{__html: intro?.description.replace(/ \?/g,'&nbsp;?')}}></p>
      <Button
        label={intro?.button}
        onClick={() => navigate(`customer`, { state: {
          texts,
          token,
          contractType,
          priceType,
          rateType
        } })}
      />
    </div>
  )
}

export default RCProIntro